module.exports = __webpack_public_path__ + "img/quizbackground-placeholder.2fa2c2f1.jpg";